import { useDispatch, useSelector } from 'react-redux';
import { toggleSideBar } from './../redux/action/sidebar.action';
import { buildParentMap, fallbackMenuIcon, normalizeBootstrapIconClass } from '../utils/sidebarUtils';
import React, { useState } from 'react';
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const SidebarItem = ({ item, onNavClick, id, parentMap, collapsed }) => {
  const dispatch = useDispatch();
  const activeMenuTabs = useSelector(state => state.sidebar?.activeMenuTabs);
  const apiIcon = normalizeBootstrapIconClass(item.iconClass ?? item.icon);
  const fallback = fallbackMenuIcon(item);
  const label = `${item?.title || ""} ${item?.content || ""}`.toLowerCase();
  const iconClassName =
    fallback && !label.includes("dashboard") ? fallback : apiIcon || fallback;

  const handleClick = () => {
    // Start from the current state
    let newState = { ...(activeMenuTabs || {}) };

    if (item.children?.length > 0) {
      // Collapse all parents first
      Object.keys(newState).forEach(key => {
        newState[key] = false;
      });

      // Toggle only the clicked parent
      newState[id] = !activeMenuTabs?.[id];

      // Ensure ancestors stay open
      if (newState[id]) {
        let current = parentMap[id];
        while (current) {
          newState[current] = true;
          current = parentMap[current];
        }
      }
    } else {
      // Leaf node → navigate
      onNavClick(item.title, item.path, item.content, iconClassName);

      // Keep ancestors expanded
      let current = parentMap[id];
      while (current) {
        newState[current] = true;
        current = parentMap[current];
      }
    }

    dispatch(toggleSideBar(newState));
  };


  return (
    <div className="sidebar-item">
      <div
        className="sidebar-title"
        onClick={handleClick}
        data-tooltip-id={`tooltip-${id}`}
        data-tooltip-content={collapsed ? item.title : ""}
      >
        <div className="icon-display">
          {iconClassName ? (
            <span className="sidebar-icon-badge">
              <i className={iconClassName} aria-hidden />
            </span>
          ) : null}
          {!collapsed && <span className="sidebar-label">{item.title}</span>}
        </div>
        {!collapsed && item.children?.length > 0 && (
          <span className="arrow">
            {activeMenuTabs?.[id] ? (
              <i className="bi bi-caret-up-fill"></i>
            ) : (
              <i className="bi bi-caret-down-fill"></i>
            )}
          </span>
        )}
      </div>

      {/* Tooltip (instant, no delay) */}
      <Tooltip id={`tooltip-${id}`} place="right" delayShow={0} />

      {item.children?.length > 0 && !collapsed && (
        <div className={`sidebar-children${activeMenuTabs?.[id] ? " is-open" : ""}`}>
          <div className="sidebar-children-inner">
            {item.children.map(child => (
              <SidebarItem
                key={child._id}
                id={child.title}
                item={child}
                onNavClick={onNavClick}
                parentMap={parentMap}
                collapsed={collapsed}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const Sidebar = ({ navData, onNavClick }) => {
  const parentMap = buildParentMap(navData);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className= {`sidebarBox ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <div
        className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}
        style={
          collapsed
            ? { width: '56px', transition: 'width .2s' }
            : { width: '225px', transition: 'width .2s' }
        }
      >
        {/* Collapse/Expand button */}
        <div
          className="sidebar-item"
          onClick={() => setCollapsed(c => !c)}
          style={{ cursor: 'pointer' }}
          title={collapsed ? 'Expand menu' : 'Collapse menu'}
        >
          <div className="sidebar-title">
            <div className="icon-display">
              <span className="sidebar-icon-badge">
                <i
                  className={`bi ${collapsed ? 'bi-chevron-double-right' : 'bi-chevron-double-left'
                    }`}
                  aria-hidden
                />
              </span>
              {!collapsed && <span className="sidebar-label">Menu</span>}
            </div>
          </div>
        </div>

        {/* Sidebar items */}
        {navData.map((item, idx) => (
          <SidebarItem
            key={`${item.id}-${item.title || idx}`}
            id={`${item.title}`}
            item={item}
            onNavClick={onNavClick}
            parentMap={parentMap}
            collapsed={collapsed} // ✅ use state, not item.collapsed
          />
        ))}



      </div>

      {/* <div className={`sidebar-footer ${collapsed ? 'sidebar-collapsed' : ''}`}>
        {!collapsed && (
          <span className="powered-by-text">Powered By</span>
        )}

        <img
          src="/trangile-logo-white.png"
          alt="Trnagile"
          className="powered-by-logo"
        />
      </div> */}
      <div className={`sidebar-footer ${collapsed ? 'sidebar-collapsed' : ''}`}>
        {!collapsed && (
          <span className="powered-by-text">Powered By</span>
        )}

        <img
          src="/trangile-logo-white.png"
          alt="Trangile"
          className="powered-by-logo"
          title="Powered By Trangile"
        />
      </div>

    </div>
  );
};

export default Sidebar;
